module.exports = __webpack_public_path__ + "img/AASLD2024.555322d7.jpg";